export default "__VITE_ASSET__DOLiqbtJ__"